import React, { useEffect, useState } from 'react';
import { isPassportExpired } from '../utils/passportValidation';

interface PassportData {
  attemptId?: string;
  surname?: string;
  name?: string;
  lastName?: string;
  document?: string;
  sex?: number;
  passportGivePlace?: string;
  passportGivePlaceId?: number;
  passportDateBegin?: string;
  passportDateEnd?: string;
  passportType?: string;
}

const VerificationSuccessPage: React.FC = () => {
  const [passportData, setPassportData] = useState<PassportData | null>(null);
  const backend = process.env.REACT_APP_BACKEND_URL || '';

  useEffect(() => {
    // Получаем transactionId из URL
    const params = new URLSearchParams(window.location.search);
    const transactionId = params.get('transactionId');
    
    if (transactionId && backend) {
      // Запрашиваем данные паспорта с бэкенда
      fetch(`${backend}/status/${encodeURIComponent(transactionId)}`)
        .then(res => res.json())
        .then(data => {
          if (data.passportData) {
            setPassportData(data.passportData);
          }
        })
        .catch(err => {
          console.error('Error loading passport data:', err);
        });
    }
  }, [backend]);

  const handleNextVerification = () => {
    window.location.href = '/';
  };

  const handleStartExam = () => {
    window.open('https://langrus.rudn.ru/login/index.php', '_blank', 'noopener,noreferrer');
  };

  const getPassportTypeName = (type?: string): string => {
    const passportTypeNames: Record<string, string> = {
      'IDMS_RECV_IP_DOCUMENTS': 'Загранпаспорт гражданина РУз',
      'IDMS_RECV_CITIZ_DOCUMENTS': 'Общегражданский биометрический паспорт',
      'IDMS_RECV_LBG_DOCUMENTS': 'Проездной документ ЛБГ',
      'IDMS_RECV_MVD_IDCARD_CITIZEN': 'ID-карта гражданина Республики Узбекистан',
      'IDMS_RECV_MVD_IDCARD_FOREIGN': 'ID-карта иностранного гражданина',
      'IDMS_RECV_MVD_IDCARD_LBG': 'ID-карта ЛБГ',
      'IDMS_RECV_MVD_IDCARD_NEWBORN': 'ID-карта новорожденного',
      'IDMS_RECV_MJ_BIRTH_CERTS': 'Свидетельства о рождении'
    };
    if (!type) return 'Не указано';
    return passportTypeNames[type] || type;
  };

  const getSexName = (sex?: number): string => {
    if (sex === 1) return 'Мужской';
    if (sex === 2) return 'Женский';
    return 'Не указано';
  };

  return (
    <div className="App" style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
      <div style={{ 
        backgroundColor: '#ffffff', 
        borderRadius: '8px', 
        padding: '30px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h1 style={{ color: '#10b981', fontSize: '28px', marginBottom: '10px' }}>
            ✅ Верификация успешно завершена
          </h1>
          <p style={{ fontSize: '16px', color: '#666' }}>
            Спасибо! Вы успешно прошли проверку.
          </p>
        </div>

        {/* Предупреждение о просроченном паспорте */}
        {passportData && isPassportExpired(passportData.passportDateEnd) && (
          <div style={{
            marginBottom: '20px',
            padding: '15px',
            backgroundColor: '#dc3545',
            color: '#ffffff',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            textAlign: 'center'
          }}>
            Паспорт просрочен.
          </div>
        )}

        {/* Данные паспорта */}
        {passportData && (
          <div style={{ 
            marginBottom: '30px', 
            padding: '20px', 
            backgroundColor: '#f5f5f5', 
            borderRadius: '8px',
            border: '1px solid #e0e0e0'
          }}>
            <h2 style={{ marginTop: 0, marginBottom: '15px', fontSize: '20px', fontWeight: '600' }}>
              Данные паспорта:
            </h2>
            <div style={{ display: 'grid', gap: '12px', fontSize: '14px' }}>
              {passportData.surname && (
                <div><strong>Фамилия:</strong> {passportData.surname}</div>
              )}
              {passportData.name && (
                <div><strong>Имя:</strong> {passportData.name}</div>
              )}
              {passportData.lastName && (
                <div><strong>Отчество:</strong> {passportData.lastName}</div>
              )}
              {passportData.document && (
                <div><strong>Серия и номер:</strong> {passportData.document}</div>
              )}
              {passportData.sex !== undefined && (
                <div><strong>Пол:</strong> {getSexName(passportData.sex)}</div>
              )}
              {passportData.passportGivePlace && (
                <div><strong>Кем выдан:</strong> {passportData.passportGivePlace}</div>
              )}
              {passportData.passportDateBegin && (
                <div><strong>Дата начала действия:</strong> {passportData.passportDateBegin}</div>
              )}
              {passportData.passportDateEnd && (
                <div><strong>Дата окончания действия:</strong> {passportData.passportDateEnd}</div>
              )}
              {passportData.passportType && (
                <div><strong>Тип документа:</strong> {getPassportTypeName(passportData.passportType)}</div>
              )}
            </div>
          </div>
        )}

        {/* Кнопки действий */}
        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
          <button
            className="secondary-button"
            onClick={handleNextVerification}
            style={{ 
              padding: '12px 24px', 
              fontSize: '16px',
              minWidth: '200px'
            }}
          >
            Следующая проверка
          </button>
          <button
            className="primary-button"
            onClick={handleStartExam}
            style={{ 
              padding: '12px 24px', 
              fontSize: '16px',
              minWidth: '200px'
            }}
          >
            Приступить к экзамену
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerificationSuccessPage;

